module.exports = __webpack_public_path__ + "static/media/icon3.31f3b1a2.svg";